import ComentarioPadrao from "pages/item_verificacao/ComentarioPadrao";
import useLocalizeStamper from "./useLocalizeStamper";

function useGlobalStamper() {
  /**
   * Shared stamper deve ser preenchido com os stamps que sejam compartilhados 
   * em mais de um contexto (feature)
   */
  useLocalizeStamper({
    context: 'shared',
    config: {
      abrangencia: 'abrangência[s]',
      amortizacao: 'amortizaç[ão|ões]',
      analise: 'análise[s]',
      autoridadeEmitente: 'autoridade[s] emitente[s]',
      carimboTempo: 'carimbo[s] do tempo',
      comentarioPadrao: 'comentários padrão',
      condicao: 'condiç[ão|ões]',
      condicaoAnalise: 'condiç[ão|ões] de análise',
      configuracao: 'configuraç[ão|ões]',
      consorcio_entidade:'consórcio[s] público[s] ou entidade[s] empresaria[l|is]',
      consultaFavorita: 'consulta[s] favorita[s]',
      contrapartida: 'contrapartida[s]',
      demandaJudicial: 'demanda[s] judicia[l|is]',
      dispositivo: 'dispositivo[s]',
      documento: 'documento[s]',
      encargos: 'encargos',
      enteFederativo: 'ente[s] federativo[s]',
      enteFederativoVinculado: 'ente[s] federativo[s] vinculado[s]',
      enteFederativoResponsavel: 'ente[s] federativo[s] responsáve[l|is]',
      entesConsorciados: 'ente[s] consorciado[s]',
      esfera: 'esfera[s]',
      etiquetaAssociada: 'etiqueta[s] associada[s]',
      finalidade: 'finalidade[s]',
      fonte: 'fonte[s]',
      formulaAnalise: 'fórmula[s] de análise',
      garantidor: 'garantidor[es]',
      liberacao: 'liberaç[ão|ões]',
      limite: 'limite[s]',
      lista: 'lista[s]',
      modeloQuadroAnalise: 'modelo do quadro[s] de análise[s]',
      modulo: 'módulo[s]',
      normativo: 'normativo[s]',
      normativoDispositivo: 'normativo[s] e dispositivo[s]',
      parcela: 'parcela[s]',
      periodicidade: 'periodicidade[s]',
      programa: 'programa[s]',
      quadroAnalise: 'quadro[s] de análise[s]',
      servico_divida:'serviço[s] da[a] dívida[s]',
      tipoAnalise: 'tipo de análise',
      tipoCertificado: 'tipo de certificado',
      tipoChecagem: 'tipo de checagem',
      tipoDocumento: 'tipo[s] do documento',
      tipoVerificacao: 'tipo[s] de verificação',
      tipoVinculacao: 'tipo[s] de vinculação',
      valorGarantia: 'valor[es] da garantia',
      nup: 'NUP',
      numeroUnicoProtocolo: 'número único de protocolo',
      identificacaoNormativo: 'identificaç[ão|ões] do[s] normativo[s]',
      tipoEntidade: 'tipo[s] de entidade[s]',
      naturezaJuridica: 'natureza[s] jurídica[s]',
      entidadeEmpresarial: 'entidade[s] empresaria[l|is]',
      consorcioPublico: 'consórcio[s] público[s]',
      codigoIbge: 'código[s] IBGE',
      organismoMultilateral: 'organismo[s] multilateral[ais]',
      agenciaGovernamental: 'agência[s] governamental[ais]',
      natureza: 'natureza[s]',
      estatal: 'estatal[ais]',
      dataContratacao: 'data[s] da[s] contrataç[ão|ões]',
      dataNormativo: 'data[s] do[s] normativo[s]',
      dataAssinatura: 'data[s] da[s] assinatura[s]',
      nomeDocumento: 'nome[s] do[s] documento[s]',
      tipoDosDocumento: 'tipo[s] do[s] documento[s]',
      dataDocumento: 'data[s] do[s] documento[s]',
      dataSituacao: 'data da situação',
      validadeDocumento: 'validade do[s] documento[s]',
      nivelAcesso: 'níve[l|is] de acesso',
      informacaoComum: 'informaç[ão|ões] comu[m|ns]',
      informacaoPessoal: 'informaç[ão|ões] pessoa[l|is]',
      pesquiseSiglaNomeCodigoIbge: 'pesquise por sigla, nome ou código IBGE',
      acessarNormativo: 'acessar normativo[s]',
      acessarDemandaJudicial: 'acessar demanda[s] judicia[l|is]',
      item: "ite[m|ns]",
      subitem: "subite[m|ns]",
      item_verificacao: "ite[m|ns] de verificação",
      itemCalculo: 'ite[m|ns] de cálculo',
      origemDocumento: 'origem do documento',
      origem: 'orige[m|ns]',
      calculo: 'cálculo[s]',
      emitidoEm: 'emitido[s] em',
      usuarioResponsavel: 'usuário[s] responsáve[l|is]'
    }
  });

  /**
   * Common stamper deve preenchido com palavras e verbos comuns com a finalidade de aumentar
   * a padronização.[ão|ões]
   */
  useLocalizeStamper({
    context: 'common', 
    config: {
      acao: 'aç[ão|ões]',
      adicionar: 'adicionar',
      ano: 'ano[s]',
      atencao: 'atenção',
      ativar: 'ativar',
      arquivo: 'arquivo[s]',
      botaoVoltar: 'retorna à página anterior',
      comentario: 'comentário',
      cnpj: 'CNPJ',
      confirmar: 'confirmar',
      consultar: 'consultar',
      contendoAlguma: 'contendo alguma desta[s]',
      contendoAlgum: 'contendo algum deste[s]',
      contendoCadaUma: 'contendo cada uma dessa[s]',
      contendoCadaUm: 'contendo cada um desse[s]',
      contendoTodos: 'contendo todos estes',
      contendoTodas: 'contendo todas estas',
      conteudo:'conteúdo[s]',
      contida: 'contida[s] a[s]',
      contido: 'contido[s] o[s]',
      cpf: 'cpf',
      dadoBasico: 'dado[s] básico[s]',
      da: 'da[s]',
      data: 'data[s]',
      dataReferencia: 'data[s] de referência',
      descartar: 'descartar',
      descartar_tip: 'descartadas as alterações desde o último salvamento',
      do: 'do[s]',
      identificacao: 'identificaç[ão|ões]',
      informacao: 'informaç[ão|ões]',
      ibge: 'ibge',
      descricao: 'descriç[ão|ões]',
      detalhe: 'detalhe[s]',
      editar: 'editar',
      email: 'e-mail',
      emSuaIntegra: 'em sua íntegra',      
      excluir: 'excluir',
      exportar: 'exportar',
      fechar: 'fechar',
      historico: 'histórico[s]',
      baixar: 'baixar',
      baixarArquivoPdf: 'baixar arquivo[s] .pdf',
      baixarDocumento: 'baixar documento[s]',
      filtro: 'filtro[s]',
      fimContratacao: 'fim[s] da[s] contrataç[ão|ões]',
      fimPeriodo: 'fi[m|ns] do[s] período[s]',
      fimVigencia: 'fi[m|ns] da[s] vigência[s]',
      habilitarEdicao: 'habilitar edição',
      identificadorSiconfi: 'identificador Siconfi',
      inativar: 'inativar',
      incluir: 'incluir',
      detalhar: 'detalhar',
      indisponivel: 'indisponíve[l|is]',
      inicioContratacao: 'início[s] da[s] contrataç[ão|ões]',
      inicioPeriodo: 'início[s] do[s] período[s]',
      inicioVigencia: 'início[s] da[s] vigência[s]',
      interessado: 'interessado[s]',
      limpar: 'limpar',
      listaDeVersoes: 'lista[s] de versões',
      mes: 'm[ês|eses]',
      metadado: 'metadado[s]',
      moeda: 'moeda[s]',
      moverCima:"Mover para cima",
      moverBaixo:"Mover para baixo",
      nenhum: 'nenhum',
      nenhuma: 'nenhuma',
      nome: 'nome[s]',
      nomeFantasia: 'nome fantasia',
      nomeReduzido: 'nome[s] reduzido[s]',
      numero: 'número[s]',      
      padrao: 'padr[ão|ões]',
      periodo: 'período[s]',
      pesquisar: 'pesquisar',
      previsualizacao: 'pré-visualizaç[ão|ões]',
      resposta: 'resposta',
      retornar: 'retornar',
      retornarPara: 'retornar para',
      salvar: 'salvar',
      salvar_tip: 'Salva este registro',
      salvar_fechar: 'salvar e fechar',
      salvar_fechar_tip: 'Salva este registro e retorna para a página de detalhe',
      sigla: 'sigla[s]',
      simboloReal: 'R$',
      situacao: 'situaç[ão|ões]',
      texto: 'texto[s]',
      tipo: 'tipo[s]',
      titulo: 'título[s]',
      uf: 'UF',
      url:'url[s]',
      valor: 'valor[es]',
      total: 'tota[l|is]',
      versaoAnterior: 'vers[ão|ões] anterior[es]',
      versaoSeguinte: 'vers[ão|ões] seguinte[s]',
      vigenteNaData: 'vigente[s] na[s] data[s]',
      visualizar: 'visualizar',
      voltar: 'voltar'
    }
  });

/*

useLocalizeStamper({
  context: 'dominio', 
  config: {

    logico: '',
    
    tipoDocumento: '',
    tipoAnalise: '',
    tipoVerificacaoCondicao: '',
    tipoVerificacaoLimite: '',
    tipoVinculoNormativo: '',
    abrangenciaEsfera: '',
    tipoPrograma: '',
    tipoModuloDemandaJudicial: '',
    tipoPeriodicidadeParametroCalculo: '',
    tipoDadoParametroCalculo: '',
    tipoEntradaParametroCalculo: '',
    tipoMes: '',
    tipoOperacaoTipoAnalise: '',
    especiePvlTipoAnalise: '',
    emissorDebentureTipoAnalise: '',
    instituicaoDebentureTipoAnalise: '',
    emissorTitulosPúblicosTipoAnalise: '',
    instituicaoTitulosPublicosTipoAnalise: '',
    tomadoresTipoAnalise: '',
    credoresTipoAnalise: '',
    garantidoresTipoAnalise: '',
    agFinanceirosTipoAnalise: '',
    tipoDirecaoQuadro: '',
    tipoRegistroQuadro: '',
    tipoMascara: '',
    tipoDivida: '',
    tipoDevedor: '',
    tipoEnte: '',
    tipoPessoa: '',
    origemEntidade: '',
   
  }
});
*/
  return null;
}

export default useGlobalStamper